// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import store from './store'

// import VueLazyload from 'vue-lazyload'

//图片懒加载
// import loading from './common/5-121204194107.gif'
// Vue.use(VueLazyload, {
//   loading
// });

/* eslint-disable no-new */

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import AwesomePicker from 'vue-awesome-picker';
Vue.use(AwesomePicker);
import $ from 'jquery'

import 'swiper/dist/css/swiper.css';

import ConfirmBox from '@/components/MessageBox/confirmBox'
Vue.prototype.$my_confirmBox = ConfirmBox.install;


import MessageBox from '@/components/MessageBox/messageBox'
Vue.prototype.$my_messageBox = MessageBox.install;

import Message from '@/components/MessageBox/message'
Vue.prototype.$my_message = Message.install;

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
});



// WEBPACK FOOTER //
// ./src/main.js